import { memo } from 'react'
import { NavItem } from '@panwds/react-nav'
import { CommentIcon } from '@panwds/icons'
import { preventDefault } from './navUtils'
import NavIcon from '../common/NavIcon'
import { _T } from '../../i18n'
import type { VFC } from 'react'

const FeedbackComp: VFC<{ isSideNavCollapsed: boolean }> = ({ isSideNavCollapsed }) => { // copied from NavItem but use a-link instead of button
  const title = _T('Feedback')
  return <>
    <li
      className='tw-flex tw-flex-col tw-min-h-0'
      data-metrics='navigation-feedback'
      data-testid='navigation-feedback'
    >
      <a
        id='sparky-feedback'
        aria-label={title}
        data-metrics='navigation-feedback'
        data-testid='navigation-feedback-link'
        href='#feedback'
        onClick={preventDefault}
        className='tw-h-10 tw-flex tw-box-border tw-m-0 tw-items-center tw-relative tw-pl-5 tw-pr-4 tw-py-2 tw-cursor-pointer hover:tw-bg-blue-steel-800 dark:hover:tw-bg-gray-800 hover:tw-text-white dark:hover:tw-text-white tw-text-blue-steel-300 dark:tw-text-gray-400 tw-border-l-4 tw-border-solid tw-border-t-0 tw-border-b-0 tw-border-r-0 tw-border-transparent tw-bg-blue-steel-900 dark:tw-bg-black'>
        <div className='tw-flex-shrink-0 tw-flex tw-items-center tw-w-4'>
          <NavIcon icon={CommentIcon} />
        </div>
        <div className='tw-box-border tw-ml-6 tw-mr-3 tw-flex tw-flex-grow tw-items-center tw-justify-between tw-overflow-hidden'>
          {!isSideNavCollapsed && <span className='tw-truncate'>{title}</span>}
        </div>
      </a>
    </li>
  </>
}
export const Feedback = Object.assign(memo(FeedbackComp), { lazy: false })

const feedbackMenuItems = [
  {
    key: 'report-issue',
    title: _T('Report an Issue'),
    path: '#report-issue',
    dataMetrics: 'nav:feedback/report-issue',
    dataTestId: 'nav:report-issue-subNavListItem',
  },
  {
    key: 'feature-request',
    title: _T('Submit Feature Request'),
    path: '#feature-request',
    dataMetrics: 'nav:feedback/feature-request',
    dataTestId: 'nav:feature-request-subNavListItem',
  },
  {
    key: 'general-feedback',
    title: _T('General Feedback'),
    path: '#general-feedback',
    dataMetrics: 'nav:feedback/general-feedback',
    dataTestId: 'nav:general-feedback-subNavListItem',
  }
]
const FeedbackMenuComp = () => {
  return <NavItem
    key='feedback'
    id='feedback'
    title={_T('Feedback')}
    displayArrow={false}
    icon={<NavIcon icon={CommentIcon} />}
  >
    {feedbackMenuItems.map((item) => <li
      key={item.key}
      data-metrics={item.dataMetrics}
      data-testid={`nav:${item.key}`}
      className='tw-box-border'>
      <a
        data-testid={item.dataTestId}
        className='tw-flex tw-box-border tw-m-0 tw-items-center tw-relative tw-pl-2 tw-pr-2 tw-py-2 tw-cursor-pointer hover:tw-bg-blue-steel-800 dark:hover:tw-bg-gray-800 hover:tw-text-white dark:hover:tw-text-white tw-text-blue-steel-300 dark:tw-text-gray-400 tw-text-sm tw-h-8 tw-ml-2 tw-border-solid tw-border-b-0 tw-border-t-0 tw-border-r-0 tw-border-l-2 tw-border-l-transparent dark:tw-border-l-transparent tw-border-blue-steel-800 dark:tw-border-gray-950 tw-bg-blue-steel-1000 dark:tw-bg-black tw-border-t-0 tw-bg-blue-steel-900 dark:tw-bg-black tw-border-transparent'
        href={item.path}
        onClick={preventDefault}
      >
        <span className='tw-truncate'>{item.title}</span>
      </a>
    </li>)}
  </NavItem>
}
export const FeedbackMenu = memo(FeedbackMenuComp)
